var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: -1,
    y: 1,
    width: 24.8,
    height: 24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "path-1",
    d: "M5.2 17l4.2 3-4.2 3v-2.3h-5v-1.5h5V17zm9.3-15.8l9.2 6.7v11.8h-7.5v-7h-3.5v7l-7.5-5.2V7.9l9.3-6.7z",
    strokeWidth: 0,
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "mBank-UI/Icons/homeArrowColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2 17l4.2 3-4.2 3v-2.3h-5v-1.5h5V17zm9.3-15.8l9.2 6.7v11.8h-7.5v-7h-3.5v7l-7.5-5.2V7.9l9.3-6.7z",
    fill: "#525455"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "mBank-Branding/Retail/Stripes",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e90a0a",
    d: "M-1 1h6.3v24H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26221e",
    d: "M5.3 1h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8600",
    d: "M6 1h6.5v24H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ae0000",
    d: "M12.4 1h4.2v24h-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065b1",
    d: "M16.7 1h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008520",
    d: "M17.1 1H23v24h-5.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.a6f2f5d931d7dd6317d598183124e6b0.svg";
export { ForwardRef as ReactComponent };